var map = {
	"./en/home1.jpg": 8305,
	"./en/home2.jpg": 534,
	"./en/home3.jpg": 9059,
	"./en/home4.jpg": 7408,
	"./flag/armenia.jpg": 3929,
	"./flag/english.jpg": 1120,
	"./flag/russian.jpg": 8087,
	"./home/aboutus.jpg": 7852,
	"./home/contactus.jpg": 1291,
	"./home/error_img.jpg": 6069,
	"./home/home5.jpg": 8585,
	"./home/img1.jpg": 6141,
	"./home/img2.jpg": 7186,
	"./home/img5.jpg": 5233,
	"./home/logo_Sm.jpg": 9495,
	"./home/logo_Sm.png": 7319,
	"./home/messegimg.jpg": 3934,
	"./hy/home1.jpg": 7009,
	"./hy/home2.jpg": 7430,
	"./hy/home3.jpg": 595,
	"./hy/home4.jpg": 9664,
	"./ru/home1.jpg": 4215,
	"./ru/home2.jpg": 3288,
	"./ru/home3.jpg": 901,
	"./ru/home4.jpg": 3566,
	"./services.jpg": 4891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;